import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { getProducts } from '../../actions/userActions/productAction'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import IconButton from '@mui/material/IconButton';
import BodySmallMedium from '../designSystem/BodySmallMedium'
import Heading6Regular from '../designSystem/Heading6Regular'
import SearchInput from '../subComponents/search/SearchInput'
import CustomButton from '../subComponents/buttons/CustomButton'
import thIcon from "../../assets/images/thIcon.svg";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import DynamicTable from '../reuse_components/DynamicTable'
import AddProducts from './AddProducts'
import CustomPagination from '../subComponents/pagination/CustomPagination'
import ItemsPerPageSelector from '../subComponents/pagination/ItemsPerPageSelector';
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";
import { t } from '../../locales/translate';

function Products() {
  const dispatch = useDispatch()
  const history = useHistory()
  const [page, setPage] = useState(1)
  const [isExpanded, setIsExpanded] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [productdata, setproductdata] = useState([]);
const [currentPage, setCurrentPage] = useState(1);
const firstPage = 1;
const [itemsPerPage, setItemsPerPage] = useState(10);

  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };
  const [selected, setSelected] = useState({
    textSearch: '',
  })
  const [filters, setFilters] = useState({
    textSearch: '',
  })
  const body = {
    filter: filters,
    pageNumber: currentPage,
    pageSize: itemsPerPage,
  }
  const products = useSelector((state) => state.products_reducer.products) || [];
 const totalPages =products.totalPages || 0;
 const totalItems = products.totalCount  || 0;
  const permissions = JSON.parse(localStorage.getItem('permissionsList'));
  const isLoading = useSelector((state) => state.products_reducer.isProductsLoading);
  useEffect(() => {
    dispatch(getProducts(body))
  }, [currentPage, filters])
 
  useEffect(() => {
   const productsData = products && products.result?.[0]?.products || [];
  const ProductsData = productsData?.map((products) => ({
    ...products,
    status: (
      <span className={products.active ? "status-badge-active" : "status-badge-inactive"}>
        {products.active ? "Active" : "Inactive"}
      </span>
    ),
  }));
  setproductdata(ProductsData);
  }, [products]);
 
  const columns = [
    { label: `${t("name")}`, accessor: "name" },
    { label: `${t("description")}`, accessor: "description" },
     { label: `${t("status")}`, accessor: "status" },  
  ];
  const handleItemsPerPageChange = (value) => {
    const body = {
      filter: filters,
      pageNumber: firstPage,
      pageSize: value,
    }
    dispatch(getProducts(body));
    setItemsPerPage(value);
    setCurrentPage(1);
  };
  const handleAddProductClick = () => {
    setEditData(null);
    setShowModal(true);
  };

  const handleEditProducts = (row) => {
    setEditData(row);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const handleSaveData = async () => {
    dispatch(getProducts(body));
    setShowModal(false);
  };
  const actions = [  
    {
        label: 'Edit Products',
        icon: <EditOutlinedIcon sx={{ color: '#0438B4' }}/>,
        permission: 'CanUpdateProduct',
        handler:handleEditProducts,
    },
];
  const handleSearch = (e) => {
    setSelected({ ...selected, ['textSearch']: e.target.value })
    if (e.target.value.length >= 1) {
      setTimeout(() => {
        setFilters({ ...filters, ['textSearch']: e.target.value })
      }, 500)
    }
    if (e.target.value == '') {
      setFilters({ ...filters, ['textSearch']: e.target.value })
    }
  }
  
  return (
    <>
      <div>
        <LoadingOverlay  isVisible={isLoading} />
      <div className="main-container">
               <div className="content-wrapper">
                <div className="pagination">
                    <SearchInput
                        placeholder="Search"
                        onChange={handleSearch}
              value={selected.textSearch}
                    />
                  <div className="flex-align-center">
                  <div className="items-per-page-container">
                  <ItemsPerPageSelector
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  />
                </div>
                        <CustomPagination
                        currentPage={currentPage}
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        totalPages={totalPages}
                        onPageChange={(page) => setCurrentPage(page)} 
                      />

                        {permissions && permissions.includes("CanAddDesignation") && (
                            <CustomButton text={t("addNew")} onClick={handleAddProductClick} />
                        )}
                    </div>
                </div>
               
            </div>
            <DynamicTable
                    data={ productdata}
                    columns={columns}
                    permissions={permissions}
                    actions={actions}
                    thIcon={thIcon}
                    showPagination={totalItems > 0}
                    currentPage={currentPage}
                    totalItems={totalItems}
                    itemsPerPage={itemsPerPage}
                    totalPages={totalPages}
                    onPageChange={(page) => setCurrentPage(page)}
                    onItemsPerPageChange={handleItemsPerPageChange}
                />
               
        </div>
        {showModal && (
        <AddProducts
          onClose={handleCloseModal}
          editData={editData}
          onSave={handleSaveData}
        />
      )}
      </div>
    
    </>
  )
}

export default Products
